import {
  collaboratorsSearchSchema,
  collaboratorsViewColumns,
  mapCollaboratorsViewQuery,
} from "./CollaboratorsView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getCollaborators } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface CollaboratorsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function CollaboratorsView(props: CollaboratorsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={collaboratorsViewColumns}
      schema={collaboratorsSearchSchema}
      mapQuery={mapCollaboratorsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getCollaborators, { retry: true })}
      actions={[
        {
          key: "view",
          label: "View",
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("PlatformCollaborators", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default CollaboratorsView;
